import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page20() {
  useEffect(() => {
    document.title = "Маяк — Страница 19"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page18" />
        <ForwardLink href="/page20" />
      </div>

      <p style={{ textAlign: "right" }}>19.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Когда работа останавливается, когда<br/>
        дует ветер и кругом вода. Депрессия.<br/>
        Депрессия. Злее чем дьявол.<br/>
        Скука делает людей злодеями...<br/>
        И вода быстро течет, парень...<br/>
        пропадает. И какой выход? Какое лекарство?<br/>
        Единственное лекарство – это выпивка.<br/>
        Пей, парень! Выпивка делает моряков<br/>
        счастливыми, приятными,<br/>
        делает их спокойными, делает их--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Тупыми.
      </p>
      <p>Пауза. Двое мужчин какое-то время смотрят друг на друга.</p>
      <p>
        СТАРИК РАЗРАЖАЕТСЯ ГРОМКИМ СМЕХОМ. Он смеется так сильно,<br/>
        что заглушает все возможные звуки. <i>Он уже пьян?</i>
      </p>
      <p>МОЛОДОЙ улыбается вопреки самому себе, трудно не улыбаться.</p>
      <p>СТАРИК наливает еще и произносит тост.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Будь я проклят, если в душе<br/>
        ты не морской волк, парень.
      </p>
      <p>МОЛОДОЙ начинает что-то говорить... но останавливается.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Выкладывай, парень.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что... Почему последний смотритель<br/>
        ушел?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Он? Мой помощник?
      </p>
      <p>МОЛОДОЙ кивает, жуя.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Он был чертовски хорошим мореплавателем.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>Умер.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --?
      </p>
      <p style={{ textAlign: "right" }}>19.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page18" />
        <ForwardLink href="/page20" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710332634/the-lighthouse-script/h5jfe0muveujmz0mq0q0.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page20;
